import styled from 'styled-components'

import { MEDIA_QUERY, TextAlign } from '../../../styles'
import { MarginProps, margin, smMargin } from '../../../styles/margin'
import { PrefixedRecord } from '../../../styles/mediaProperties'
import { PaddingProps, padding, smPadding } from '../../../styles/padding'


export type ContentWidthType = 'medium' | 'large' | 'full' | 'small' | 'extraSmall'

const widthMap: Record<ContentWidthType, string> = {
  medium: '1230px',
  large: '1380px',
  small: '850px',
  extraSmall: '768px',
  full: '100%'
}

interface ContentBaseProps {
  contentWidth: ContentWidthType | number
}

interface ContentResponsiveProps extends MarginProps, PaddingProps {
  textAlign?: TextAlign
}

interface ContentProps extends ContentBaseProps, ContentResponsiveProps, PrefixedRecord<'sm', ContentResponsiveProps> {}

export const Content = styled('div').withConfig({
  shouldForwardProp: (prop) =>
    !['contentWidth', 'textAlign', 'mt', 'mb', 'mr', 'ml', 'pt', 'pb', 'pr', 'pl', 'm', 'p'].includes(prop) &&
    !prop.startsWith('sm-')
})<ContentProps>`
  margin: auto;
  width: ${({ contentWidth }) =>
    typeof contentWidth === 'number' ? `min(${contentWidth}px,100%)` : `min(${widthMap[contentWidth]},100%)`};
  text-align: ${(props) => props.textAlign ?? 'left'};
  ${margin};
  ${padding};
  @media ${MEDIA_QUERY.TABLET} {
    min-width: 100%;
    max-width: 100%;
    padding: 0 15px;
    ${smMargin};
    ${smPadding};
  }
  @media ${MEDIA_QUERY.MOBILE} {
    min-width: 100%;
    max-width: 100%;
    padding: 0 15px;
    ${smMargin};
    ${smPadding};
  }
`
